import { render, staticRenderFns } from "./PostListItem.vue?vue&type=template&id=79d1ba34&scoped=true&"
import script from "./PostListItem.vue?vue&type=script&lang=js&"
export * from "./PostListItem.vue?vue&type=script&lang=js&"
import style0 from "./PostListItem.vue?vue&type=style&index=0&id=79d1ba34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d1ba34",
  null
  
)

export default component.exports